import React from "react";
import { object } from "prop-types";

import MyReport from "../../molecules/my-report";
import CustomStoryCard1 from "../../molecules/custom-story-card1";
import CustomStoryCard2 from "../../molecules/custom-story-card2";
import CustomStoryCard3 from "../../molecules/custom-story-card3";
import { Responisive337x280Container } from "../../rows/ad-free";
import LatestNews from "../latest-news";

import "./eightStoriesWithAdWidget.m.css";

const EightStoriesWithAdWidget = ({ collection }) => {
  if (!(collection && collection.items)) {
    return null;
  }

  const stories = collection.items.filter((item) => item.type === "story").map((item) => item.story);

  const sponsoredCollection = collection.items.find((i) => i.type === "collection");

  let sponsoredStories = [];
  if (sponsoredCollection) {
    sponsoredStories = sponsoredCollection.items.filter((i) => i.type === "story").map((item) => item.story);
  }

  if (!stories.length) {
    return null;
  }

  return (
    <div styleName="wrapper" className="container" id={collection.slug}>
      <div styleName="col-1">
        {stories.splice(0, 1).map((item, index) => (
          <CustomStoryCard1 story={item} key={index} showAuthorName={true} />
        ))}
        {collection.latestNews ? <LatestNews collection={collection.latestNews} className="desktop-hide" /> : null}
        <div styleName="col-1-wrapper">
          <div styleName="stories">
            {stories.splice(0, 2).map((item, index) => (
              <CustomStoryCard2 story={item} key={index} />
            ))}
            {stories.splice(0, 1).map((item, index) => (
              <CustomStoryCard3 story={item} key={index} headerType={3} showHeadlineIcon />
            ))}
          </div>
          {stories.splice(0, 1).map((item, index) => (
            <CustomStoryCard1 story={item} key={index} headerType={11} showAuthorName={true} />
          ))}
        </div>
      </div>
      <div styleName="col-2">
        <Responisive337x280Container desktop="rightATF" mobile="mid1" />

        <div styleName="custom-story-card-2-stories">
          {sponsoredStories.length
            ? sponsoredStories.splice(0, 1).map((item, index) => <CustomStoryCard2 story={item} key={index} />)
            : stories.splice(0, 1).map((item, index) => <CustomStoryCard2 story={item} key={index} />)}
          {sponsoredStories.length
            ? sponsoredStories.splice(0, 1).map((item, index) => <CustomStoryCard2 story={item} key={index} />)
            : stories.splice(0, 1).map((item, index) => <CustomStoryCard2 story={item} key={index} />)}
        </div>
        <>
          {sponsoredStories.length
            ? sponsoredStories
                .splice(0, 1)
                .map((item, index) => <CustomStoryCard3 story={item} key={index} headerType={3} showHeadlineIcon />)
            : stories
                .splice(0, 1)
                .map((item, index) => <CustomStoryCard3 story={item} key={index} headerType={3} showHeadlineIcon />)}
        </>
        <MyReport />
      </div>
    </div>
  );
};

EightStoriesWithAdWidget.propTypes = {
  collection: object.isRequired,
};

export default EightStoriesWithAdWidget;
